import { useEffect, useState } from "react";
import { readTipper } from "@/lib/tipper";

/** React hook that stays in sync with the localStorage supporter flag. */
export default function useTipper() {
  const [tipper, setTipper] = useState(() => readTipper());
  useEffect(() => {
    const onChange = () => setTipper(readTipper());
    window.addEventListener("vault:tipper-changed", onChange);
    window.addEventListener("storage", onChange);
    return () => {
      window.removeEventListener("vault:tipper-changed", onChange);
      window.removeEventListener("storage", onChange);
    };
  }, []);
  return tipper;
}
